/**
 * Disclaimer-Wortlaute für In-App-Hinweise zu Pflanzendaten.
 *
 * Single Source of Truth: docs/legal/HAFTUNG_PFLANZENDATEN.md § 2.
 * Änderungen am Wortlaut zuerst dort, dann hier spiegeln.
 *
 * Verwendet von: DataDisclaimerBadge, HardinessWarningBadge.
 *
 * Issue: #286 (Haftungsausschluss für Pflanzendaten)
 */

// Re-export aus legal.js (Single Source of Truth, #245).
export { AGB_URL } from './legal';

/**
 * Emergency poison control numbers per country (ISO country name as stored in GardenSettingsContext).
 * Shape: { label, tel, region } — region is used in "in {region} {label}" sentences.
 *
 * Sources (Stand 2026-05-05): docs/legal/HAFTUNG_PFLANZENDATEN.md § 2.1
 *
 * Issue: #321
 */
export const TOXICITY_EMERGENCY_NUMBERS = {
  Deutschland: { label: '030 19240', tel: '+493019240', region: 'Deutschland' },
  Österreich: { label: '01 406 43 43', tel: '+4314064343', region: 'Österreich' },
  Schweiz: { label: '145', tel: '145', region: 'der Schweiz' },
};

/** Backward-compat alias — do not remove; used in existing tests and components. */
export const POISON_HOTLINE_DE = TOXICITY_EMERGENCY_NUMBERS.Deutschland;

/**
 * Returns the poison hotline for the given country name.
 * Falls back to DE when country is unknown, null, or undefined.
 *
 * @param {string|null|undefined} country - Country name from GardenSettingsContext (e.g. 'Österreich')
 */
export function getPoisonHotline(country) {
  return TOXICITY_EMERGENCY_NUMBERS[country] ?? TOXICITY_EMERGENCY_NUMBERS.Deutschland;
}

/**
 * Wortlaute pro Variant. `sourceText` spiegelt den Klartext aus
 * HAFTUNG_PFLANZENDATEN.md § 2 (für Wortlaut-Sync-Test in Chunk C).
 */
export const DISCLAIMER_TEXTS = {
  toxicity: {
    role: 'alert',
    ariaLabel: 'Sicherheitshinweis zu Giftigkeitsangaben',
    sourceText:
      'Giftigkeitsangaben sind Orientierung. Bei Verdacht auf Vergiftung den Giftnotruf anrufen — in Deutschland 030 19240 — oder direkt zum Tierarzt. Verbindliche Bedingungen: AGB.',
  },
  care: {
    role: 'note',
    ariaLabel: 'Hinweis zu Pflegeempfehlungen',
    sourceText:
      'Pflegeempfehlungen sind Orientierung — keine Erfolgszusage. Verbindliche Bedingungen: AGB.',
  },
  hardiness: {
    role: 'note',
    ariaLabel: 'Hinweis zu Winterhärtezonen',
    sourceText:
      'Zonen-Angaben sind 30-Jahres-Mittelwerte (1991–2020), kein Wettergarant.',
  },
};
